import { getSentimentColor } from '@modules/common/utils';
import { SentimentName, SentimentType } from 'v2/core/entities/fields';

const NEUTRAL = '#7D5800';

export const getTextSentimentColor = (
  sentiment: SentimentName | SentimentType | string,
) => {
  switch (sentiment) {
    case SentimentName.NEUTRAL:
    case SentimentType.Neutral:
      return NEUTRAL;
    default:
      return getSentimentColor(sentiment);
  }
};
